import React, { useState } from "react"
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Collapse,
} from "@mui/material"
import pending from "../../images/pending.png"
import { FaChevronLeft, FaChevronDown, FaChevronUp } from "react-icons/fa6"
import * as Style from "./style"
import { Link, useNavigate, useParams } from "react-router-dom"
import dummyImage from "../../images/dummy-icon.png"
import chatimage from "../../images/chatimage.png"
import {
  useAcceptGenrateBookingQuery,
  useGetPostTimeLineQuery,
} from "../../features/OverViewAuth/overViewApi"
import moment from "moment"
import RatingStars from "../common/rating"
interface DateProps {
  dateString: string
}

const FormatDate = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <>{utcDate.format("dddd")}</>
}

const FormatTime = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("D-MMMM")}</div>
}

const FormatChangeTime = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div> {utcDate.format("h:mm A")}</div>
}

const FormatDateMonthDay = ({ dateString }: DateProps) => {
  const utcDate = moment.utc(dateString).local()
  return <div>{utcDate.format("DD MMM, dddd")}</div>
}
import CenteredSpinner from "../common/CenteredSpinner"
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab"
import { CiMail } from "react-icons/ci"
import { LuPhone } from "react-icons/lu"
import { BsInfoCircleFill } from "react-icons/bs"
import { useCreateTicketMutation } from "../../features/ChatAuth/chatApi"
import PreviewImage from "../common/previewImage"
import TimeChangeModal from "../common/commonModal/timeChangeModal"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
import { Flexbox } from "../Myaccount/style"

const BookingServiceDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [showFullTimeline, setShowFullTimeline] = useState(false)
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [timeModal, setTimeModal] = useState<boolean>(false)
  const [showExtraDetails, setShowExtraDetails] = useState(false)

  const handleToggleTimeline = () => {
    setShowFullTimeline(!showFullTimeline)
  }
  const {
    data: upcomingBooking,
    isLoading,
  } = useAcceptGenrateBookingQuery({ id })
  const {
    data: timeLine,
    isLoading: timeisLoading,
    isFetching: timeisFetching,
  } = useGetPostTimeLineQuery({ id })
  const [chatView, { data: CharacterData }] = useCreateTicketMutation()
  const handleChatView = async () => {
    const payload = {
      postId: id,
    }
    try {
      const response: any = await chatView(payload)
      if (response?.data?.status === 200) {
        const chatId = response.data?.data?._id
        const adminId = response.data?.data?.adminstration

        if (chatId && adminId) {
          navigate(`/dashboard/help-center?chatId=${chatId}&adminId=${adminId}`)
        } else {
          console.error("Invalid chatId or adminId in response:", response)
        }
      } else {
        console.error("API call was not successful:", response)
      }
    } catch (error) {
      console.error("Error making API call:", error)
    } finally {
    }
  }

  const handleImageClick = (image: string) => {
    setSelectedImage(image)
  }

  const handleClosePreview = () => {
    setSelectedImage(null)
  }

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <Box className="">
            {upcomingBooking?.data &&
              upcomingBooking?.data?.map((item: any, index: number) => (
                <Style.Overview key={index}>
                  <TimeChangeModal
                    OpenModal={timeModal}
                    handleClose={setTimeModal as any}
                    bookingInfo={item}
                  />
                  <Box className="feature-card py-4 px-2">
                    <Box className="d-md-flex d-block justify-content-between align-items-center pb-3">
                      <Box className="d-flex align-items-center gap-1 gap-md-4">
                        <Button
                          className="back-btn mb-0"
                          onClick={() => navigate(-1)}
                        >
                          <FaChevronLeft />
                        </Button>
                        <Typography variant="h2" className=" mb-0">
                          Service Details
                        </Typography>
                      </Box>

                      {/* <Box className="d-flex align-items-center gap-3 pt-2 pt-md-0">
                        {(item.status == "Applied" ||
                          item.status == "Generated") && (
                          <Typography>
                            <span
                              className="view-profile"
                              onClick={() => setTimeModal(true)}
                            >
                              Change Booking Timing
                            </span>
                          </Typography>
                        )}

                        <Typography className="status-text mb-0">
                          Status - {" "}
                          <span
                            className="completed fw-bold"
                            style={{
                              color:
                                item.status == "Completed"
                                  ? "green"
                                  : item.status == "Declined"
                                  ? "red"
                                  : item.status == "Expired"
                                  ? "blue"
                                  : "",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.status}
                          </span>
                        </Typography>
                      </Box> */}
                    </Box>

                    <Grid container className="p-4">
                      {/* Left Side - 40% */}
                      <Grid
                        item
                        xs={12}
                        md={5}
                        lg={5}
                        xl={5}
                        className="pe-2 pe-xl-4"

                      >
                        {item?.seekerData?.email && (
                          <Box className="text-center d-flex flex-column align-items-center h-100">
                            <Box className="mb-3">
                              <img
                                src={item?.seekerData?.profilePic || dummyImage}
                                className="profile-img-2"
                              />
                            </Box>
                            <Typography
                              variant="h2"
                              className="mb-2 fs-5 fw-600 text-black text-capitalize"
                            >
                              {item?.seekerData?.name || "-----"}
                            </Typography>
                            <Typography
                              variant="body1"
                              className="mb-2 fw-bold d-inline-flex gap-1 align-items-center"
                            >
                              <CiMail style={{ color: "#f475A4" }} />
                              <span
                                className="text-truncate"
                                style={{ width: "180px" }}
                              >
                                {item?.seekerData?.email}
                              </span>
                              <Tooltip
                                title={item?.seekerData?.email || "-----"}
                                arrow
                              >
                                <Button
                                  style={{ minWidth: "10px" }}
                                  className="m-0 p-0"
                                >
                                  <BsInfoCircleFill color="#F475A4" />
                                </Button>
                              </Tooltip>
                            </Typography>
                            <Typography
                              variant="body1"
                              className="fw-bold mb-3"
                            >
                              <LuPhone style={{ color: "#f475A4" }} />{" "}
                              {item?.seekerData?.contactNo || "-----"}
                            </Typography>
                          </Box>
                        )}
                      </Grid>

                      {/* Right Side - 60% */}
                      <Grid
                        item
                        xs={12}
                        md={7}
                        lg={7}
                        xl={7}
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                        }}
                      >
                        <Box>
                          {[
                            {
                              label: "Service Required",
                              value: item?.service?.name,
                            },
                            {
                              label: "Number Of Providers Required",
                              value: item?.personRequired,
                            },
                            {
                              label: "Service Date",
                              value: item?.from
                                ? moment.utc(item?.from).local().format("DD MMM, dddd YYYY")
                                : "-----",
                            },
                            {
                              label: "Language",
                              value: item?.language?.join(", "),
                            },
                            {
                              label: "Location",
                              value: item?.location,
                            },
                            {
                              label: "Additional Instructions",
                              value: item?.description,
                            },
                          ].map(
                            (field, index) =>
                              field.value && (
                                <Box
                                  key={index}
                                  className="p-3 mb-3"
                                  style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    className="fw-bold text-#000 mb-1"
                                  >
                                    {field.label}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    className="text-black"
                                    style={{ overflowWrap: "anywhere" }}
                                  >
                                    {field.value || "-----"}
                                  </Typography>
                                </Box>
                              ),
                          )}

                          {/* Attachments */}
                          {item?.attachments?.length > 0 && (
                            <Box
                              className="p-3 mb-3"
                              style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                className="fw-bold mb-2"
                              >
                                Uploaded Photos
                              </Typography>
                              <Box className="d-flex flex-wrap gap-2">
                                {item?.attachments.map(
                                  (imagePost: any, idx: number) => (
                                    <img
                                      key={idx}
                                      src={imagePost}
                                      className="photo-upload me-2"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleImageClick(imagePost)
                                      }
                                    />
                                  ),
                                )}
                              </Box>
                            </Box>
                          )}

                          <PreviewImage
                            selectedImage={selectedImage}
                            handleClosePreview={handleClosePreview}
                          />
                        </Box>
                      </Grid>
                    </Grid>

                    {/* Additional Info Section - Below the service details container */}
                    {item?.extraDetails && (
                      <Box className="px-4 mt-4">
                        <Button
                          variant="outlined"
                          onClick={() => setShowExtraDetails(!showExtraDetails)}
                          className="text-capitalize d-flex align-items-center gap-0"
                          style={{
                            borderColor: "#F475A4",
                            color: "#F475A4",
                            fontWeight: "600",
                            padding: "8px 16px",
                          }}
                        >
                          {showExtraDetails ? (
                            <>
                              <FaChevronUp size={14} className="me-2" />
                              Hide Additional Information
                            </>
                          ) : (
                            <>
                              <FaChevronDown size={14} className="me-2" />
                              Show Additional Information
                            </>
                          )}
                        </Button>

                        <Collapse in={showExtraDetails}>
                          <Box className="mt-3 p-2 border rounded">
                            <ExtraDetailsDisplay
                              extraDetails={item.extraDetails}
                              serviceType={item?.data?.serviceType || item?.data?.service?.name}
                            />
                          </Box>
                        </Collapse>
                      </Box>
                    )}

                    {item?.assignedTo?.length > 0 ? (
                      <>
                        <Box className="mt-4 px-4">
                          <Typography align="left" variant="h2" mb={2}>
                            Service Providers Details
                          </Typography>
                        </Box>
                        <TableContainer
                          component={Paper}
                          className="dashboard-table-wrapper custom-scrollbar overflow-y-hidden mh-1 mx-4"
                        >
                          <Table
                            style={{
                              minWidth: 650,
                              border: "none",
                              backgroundColor: "#fff",
                              borderRadius: "16px",
                              overflow: "hidden",
                            }}
                            className="dashboard-table"
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell
                                  align="center"
                                  className="service-head"
                                >
                                  Service Provider
                                </TableCell>
                                <TableCell align="center">Phone</TableCell>
                                <TableCell align="center">Email</TableCell>
                                <TableCell align="center">Language</TableCell>
                                <TableCell align="center">Action</TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {item.assignedTo.map((row: any) => (
                                <TableRow
                                  key={row.name}
                                  sx={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate(
                                      `/dashboard/provider-profile/${row._id}`,
                                    )
                                  }
                                >
                                  <TableCell>
                                    <div className="img-wrapper ms-1">
                                      <img
                                        src={row.profilePic || dummyImage}
                                        alt={row.name}
                                        style={{
                                          width: "74px",
                                          height: "74px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    align="center"
                                    scope="row"
                                  >
                                    <span className="text flex-column gap-2">
                                      {row.name || "--"}
                                      <span className="minh-1">
                                        <RatingStars
                                          rating={row.rating?.$numberDecimal}
                                        />
                                      </span>
                                    </span>
                                  </TableCell>
                                  <TableCell align="center">
                                    <span>{row.contactNo}</span>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Tooltip title={row.email || ""} arrow>
                                      <span>
                                        {row.email && row.email.length > 15
                                          ? `${row.email.slice(0, 15)}...`
                                          : row.email}
                                      </span>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell align="center">
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        gap: "8px",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        padding: "4px",
                                      }}
                                    >
                                      {row?.language &&
                                        row.language.length > 0 ? (
                                        row.language.map(
                                          (lang: string, idx: number) => (
                                            <div
                                              key={idx}
                                              style={{
                                                border: "1px solid #fff",
                                                backgroundColor: "#f475A4",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "2px 8px",
                                                minHeight: "40px",
                                                color: "#fff",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                              }}
                                            >
                                              {lang}
                                            </div>
                                          ),
                                        )
                                      ) : (
                                        <span style={{ color: "#999" }}>
                                          -----
                                        </span>
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell align="center">
                                    <span>
                                      <Link
                                        to={`/dashboard/provider-profile/${row._id}`}
                                        className="view-profile"
                                      >
                                        View Profile
                                      </Link>
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : item?.status == "Declined" ||
                      item?.status == "Expired" ? (
                      ""
                    ) : (
                      <Box className="not-assigned d-flex align-items-center gap-2 mt-5 px-4">
                        <div className="not-assigned-wrapper mt-2 ps-1">
                          <h4>Service Provider Is Not Assigned Yet</h4>
                          <p>
                            We Will Notify You Once Service Provider Is Assigned
                            To You
                          </p>
                        </div>
                        <div className="pending-icon">
                          <img src={pending} />
                        </div>
                      </Box>
                    )}
                  </Box>
                  {(item?.status == "Accepted" || item?.status == "Active" || item?.status == "Inprogress") && (
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "50px",
                        padding: "0 16px",
                      }}
                    >
                      <Button
                        className="timeline-btn me-4"
                        onClick={handleChatView}
                      >
                        Chat
                        <img
                          src={chatimage}
                          alt="img"
                          style={{ marginLeft: "10px" }}
                        />
                      </Button>
                    </Box>
                  )}
                </Style.Overview>
              ))}
          </Box>
          {timeLine !== undefined && (
            <Style.Overview>
              <Box
                className="d-flex my-5"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography align="left" variant="h2" mb={2}>
                  Timeline
                </Typography>
              </Box>

              <Box
                className="timeline-graph"
                sx={{
                  "& ul:last-of-type:before": {
                    width: "0!important",
                  },
                }}
              >
                {timeLine?.data
                  ?.slice(0, showFullTimeline ? timeLine?.data?.length : 3)
                  .map((timeline: any, index: number) => (
                    <Timeline
                      key={timeline._id}
                      position={index % 2 === 0 ? "alternate" : "left"}
                    >
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{
                            m: "10px 0 0",
                            "@media (max-width: 768px)": {
                              flex: "0 0 auto",
                              padding: "0 8px 0 0"
                            }
                          }}
                          align="right"
                          className="timeline-desc"
                          color="text.secondary"
                        >
                          <span className="datetime">
                            <span className="d-flex flex-column">
                              <span className="weekday">
                                <FormatDate dateString={timeline.createdAt} />
                              </span>
                              <span>
                                <FormatChangeTime
                                  dateString={timeline.createdAt}
                                />
                              </span>
                              <span>
                                <FormatTime dateString={timeline.createdAt} />
                              </span>
                            </span>
                          </span>
                          <br />
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot>
                            <Typography className="timeline-step">
                              0{timeLine?.data?.length - index}
                            </Typography>
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{
                          py: "12px",
                          px: 0.5,
                          "@media (max-width: 768px)": {
                            flex: "1 0 auto",
                            padding: "0 0 0 8px"
                          }
                        }}>
                          <Box className="timeline-content">
                            <Typography className="timeline-heading">
                              Status - {timeline?.postStatus}{" "}
                            </Typography>
                            <Typography className="timeline-desc"></Typography>
                            <Typography className="timeline-desc">
                              {timeline?.message}{" "}
                            </Typography>
                          </Box>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  ))}
                <div className="d-flex justify-content-center">
                  {timeLine?.data.length > 3 && (
                    <Button
                      onClick={handleToggleTimeline}
                      className="view-profile py-2 text-capitalize"
                      sx={{
                        "@media (max-width: 768px)": {
                          padding: "8px 16px",
                          fontSize: "14px"
                        }
                      }}
                    >
                      {showFullTimeline ? "Show Less" : "Show More"}
                    </Button>
                  )}
                </div>
              </Box>
            </Style.Overview>
          )}
        </>
      )}
    </>
  )
}
export default BookingServiceDetails